import { gql } from "@apollo/client"

const QUERY = gql`
    query dashboardData($department: String) {
        stats(department: $department) {
            shopStats {
                name
                lang
                countPriceChangesLastTwoWeeks
                tarifComparisonStats {
                    name
                    shopName
                    valueA
                    urlA
                    valueB
                    urlB
                    valueC
                    urlC
                    totalCount
                }
            }
            competitorWithMostPriceChanges
            competitorsWithLowestPrice
            competitorWithLowestPrices
            competitorsMappingHistory
            activeShops
            crawlsToday
            productsPriceHigher
            productsPriceEqual
            productsPriceLower
            productsPriceHigherTotal
            productsPriceEqualTotal
            productsPriceLowerTotal
            productsPriceHigherByCategory {
                name
                count
                totalCount
                percentage
            }
            productsPriceLowerByCategory {
                name
                count
                totalCount
                percentage
            }
            productsPriceEqualByCategory {
                name
                count
                totalCount
                percentage
            }
            productsPriceHigherByCategoryTotal {
                name
                count
                totalCount
                percentage
            }
            productsPriceLowerByCategoryTotal {
                name
                count
                totalCount
                percentage
            }
            productsPriceEqualByCategoryTotal {
                name
                count
                totalCount
                percentage
            }
            productsPriceHigherByProducer {
                name
                count
                totalCount
                percentage
            }
            productsPriceLowerByProducer {
                name
                count
                totalCount
                percentage
            }
            productsPriceEqualByProducer {
                name
                count
                totalCount
                percentage
            }
            productsPriceHigherByProducerTotal {
                name
                count
                totalCount
                percentage
            }
            productsPriceLowerByProducerTotal {
                name
                count
                totalCount
                percentage
            }
            productsPriceEqualByProducerTotal {
                name
                count
                totalCount
                percentage
            }
            productsPriceHigherByShops {
                id
                name
                lang
                count
                totalCount
                percentage
            }
            productsPriceLowerByShops {
                id
                name
                lang
                count
                totalCount
                percentage
            }
            productsPriceEqualByShops {
                id
                name
                lang
                count
                totalCount
                percentage
            }
            productsPriceHigherByShopsTotal {
                id
                name
                lang
                count
                totalCount
                percentage
            }
            productsPriceLowerByShopsTotal {
                id
                name
                lang
                count
                totalCount
                percentage
            }
            productsPriceEqualByShopsTotal {
                id
                name
                lang
                count
                totalCount
                percentage
            }
            crawlerCountSeries
            shopsProductAllCounts {
                name
                lang
                countProducts
            }
            shopsProductMappedCounts {
                name
                lang
                countMappedProducts
            }
            lastUpdate
            filterDepartment
        }
        baseData {
            mainLang
            tariffComparisonMode
            demoMode
            categories {
                ...dashboardSelectFields
                type
            }
        }
        settings {
            presets {
                id
                name
                userId
                shops {
                    shop {
                        lang
                        name
                        value: id
                    }
                }
            }
            customerActiveShops {
                id
                name
                shortName
                lang
            }
        }
    }
    fragment dashboardSelectFields on Category {
        name
        value: name
        label: name
    }
`

const queryActiveShopInfos = gql`
    query activeShopInfos {
        shops(onlyActive: true) {
            id
            name
            lang
            domain
        }
    }
`

export { QUERY, queryActiveShopInfos }
